import "../lib/alertify/alertify.core.css";
import "../lib/alertify/alertify.espatial.css";

const alertify = global.alertify;

export default class Alert {
    /**
     * 
     * @param args 
     * 
     * @returns 
     */
    alertOk(...args) {
        alertify.set({
            transition: 'fade',
            title: $i18n("eSpatial"),
            labels: {
                ok: $i18n("OK"),
            },
            allowClose: false,
        });

        if (typeof args[0] === "object") {
            this.runWithSettingsObject("alert", args[0]);
            return;
        }

        this.parseArgumentsAndRun("alert", args);
    }

    /**
     * 
     * @param args 
     * 
     * @returns 
     */
    alertClose(...args) {
        alertify.set({
            transition: 'fade',
            title: $i18n("eSpatial"),
            labels: {
                ok: $i18n("CLOSE"),
            },
            allowClose: true,
        });

        if (typeof args[0] === "object") {
            this.runWithSettingsObject("alert", args[0]);
            return;
        }

        this.parseArgumentsAndRun("alert", args);
    }

    /**
     * 
     * @param args 
     * 
     * @returns 
     */
    confirm(...args) {
        alertify.set({
            transition: 'fade',
            title: $i18n("eSpatial"),
            labels: {
                ok: $i18n("OK"),
                cancel: $i18n("CANCEL")
            },
            buttonReverse: true,
            allowClose: false,
        });

        if (typeof args[0] === "object") {
            this.runWithSettingsObject("confirm", args[0]);
            return;
        }

        this.parseArgumentsAndRun("confirm", args);
    }

    /**
     * 
     * @param args 
     * 
     * @returns 
     */
    yesNo(...args) {
        alertify.set({
            transition: 'fade',
            title: $i18n("eSpatial"),
            labels: {
                ok: $i18n("YES"),
                cancel: $i18n("NO")
            },
            buttonReverse: true,
            allowClose: false,
        });

        if (typeof args[0] === "object") {
            this.runWithSettingsObject("confirm", args[0]);
            return;
        }

        this.parseArgumentsAndRun("confirm", args);
    }

    /**
     * 
     * @param args 
     * 
     * @returns 
     */
    prompt(...args) {
        alertify.set({
            transition: 'fade',
            title: $i18n("eSpatial"),
            labels: {
                ok: $i18n("OK"),
                cancel: $i18n("CANCEL")
            },
            buttonReverse: true,
            allowClose: true,
        });

        if (typeof args[0] === "object") {
            this.runWithSettingsObject("prompt", args[0]);
            return;
        }

        this.parseArgumentsAndRun("prompt", args);
    }

    /**
     * 
     * @param args 
     * 
     * @returns 
     */
    success(...args) {
        if (typeof args[0] === "object") {
            this.runWithSettingsObject("prompt", args[0]);
            return;
        }
        
        this.parseArgumentsAndRun("success", args);
    }

    /**
     * 
     * @param args 
     * 
     * @returns 
     */
    warning(...args) {
        if (typeof args[0] === "object") {
            this.runWithSettingsObject("prompt", args[0]);
            return;
        }

        this.parseArgumentsAndRun("warning", args);
    }

    /**
     * 
     * @param args 
     * 
     * @returns 
     */
    error(...args) {
        if (typeof args[0] === "object") {
            this.runWithSettingsObject("prompt", args[0]);
            return;
        }

        this.parseArgumentsAndRun("error", args);
    }

    /**
     * 
     * @param args 
     * 
     * @returns 
     */
    message(...args) {
        if (typeof args[0] === "object") {
            this.runWithSettingsObject("prompt", args[0]);
            return;
        }

        this.parseArgumentsAndRun("prompt", args);
    }

    /**
     * 
     * @param type 
     * @param args 
     */
    private parseArgumentsAndRun(type: string, args: any[]) {
        const parsedArgs = {};

        switch (args.length) {
            case 1:
                parsedArgs.message = args[0]
                break;
            case 2:
                if (typeof args[0] === "string" && typeof args[1] === "string") {
                    parsedArgs.title = args[0];
                    parsedArgs.message = args[1];
                } else if (typeof args[0] === "string" && typeof args[1] === "function") {
                    parsedArgs.message = args[0];
                    parsedArgs.okCallback = args[1];
                } else {
                    throw new Error("invalid parameters: "+ args);
                }
                break;
            case 3:
                if (type === "prompt" && typeof args[0] === "string" && typeof args[1] === "string" && (typeof args[2] === "function" || args [2] === undefined)) {
                    parsedArgs.message = args[0];
                    parsedArgs.promptValue = args[1];
                    parsedArgs.okCallback = args[2];
                } else if (typeof args[0] === "string" && (typeof args[1] === "function" || args[1] === undefined) && (typeof args[2] === "function" || args [2] === undefined)) {
                    parsedArgs.message = args[0];
                    parsedArgs.okCallback = args[1];
                    parsedArgs.cancelCallback = args[2];
                } else if (typeof args[0] === "string" && typeof args[1] === "string" && typeof args[2] === "function") {
                    parsedArgs.title = args[0];
                    parsedArgs.message = args[1];
                    parsedArgs.okCallback  = args[2];
                } else {
                    throw new Error("invalid parameters: "+ args);
                }
                break;
            case 4:
                if (type === "prompt" && typeof args[0] === "string" && (typeof args[1] === "string") && (typeof args[2] === "function" || args [2] === undefined) && (typeof args[3] === "function" || args [3] === undefined) ) {
                    parsedArgs.message = args[0];
                    parsedArgs.promptValue = args[1]
                    parsedArgs.okCallback = args[2];
                    parsedArgs.cancelCallback = args[3];
                } else if (typeof args[0] === "string" && typeof args[1] === "string" && (typeof args[2] === "function" || args[2] === undefined) && (typeof args[3] === "function" || args [3] === undefined)) {
                    parsedArgs.title = args[0];
                    parsedArgs.message = args[1];
                    parsedArgs.okCallback = args[2];
                    parsedArgs.cancelCallback = args[3];
                } else {
                    throw new Error("invalid parameters: "+ args);
                }
                break;
            case 5:
                if (type === "prompt" && typeof args[0] === "string" && (typeof args[1] === "string") && (typeof args[2] === "string") && (typeof args[3] === "function" || args [3] === undefined) && (typeof args[4] === "function" || args [4] === undefined) ) {
                    parsedArgs.title = args[0];
                    parsedArgs.message = args[1];
                    parsedArgs.promptValue = args[2]
                    parsedArgs.okCallback = args[3];
                    parsedArgs.cancelCallback = args[4];
                } else {
                    throw new Error("invalid parameters: "+ args);
                }
                break;
        }

        if (parsedArgs.title) {
            alertify.set({title: parsedArgs.title});
        }

        const callbackFunc = (ok, value) => {
            if(ok && parsedArgs.okCallback) {
                parsedArgs.okCallback(value);
            } else if (parsedArgs.cancelCallback) {
                parsedArgs.cancelCallback();
            }
        }

        // can be useful for debug purposes to the stack of a popup
        es.log.log("alertify", parsedArgs);

        alertify[type](parsedArgs.message, callbackFunc, parsedArgs.promptValue ? parsedArgs.promptValue : undefined );
    }

    /**
     * 
     * @param type 
     * @param settingsObj 
     */
    private runWithSettingsObject(type: string, settingsObj) {
        const args = [];
        if (settingsObj.title) {
            args.push(settingsObj.title)
        }
        if (!settingsObj.message) {
            throw new Error("invalid parameters: .message prop parameter is mandatory: " + JSON.stringify(settingsObj, null, 4));
        }
        args.push(settingsObj.message);
        args.push(settingsObj.onok);
        args.push(settingsObj.oncancel);

        alertify.set(settingsObj);

        this.parseArgumentsAndRun(type, args);
    }
}
